import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Loader } from 'rsuite';
import {
  cancelPostAction,
  createMediaSubmission,
  getCampaignElementById,
  getCampaignId,
  getIpAddress,
  getIsVideoUploadingToBucket,
  getPreSignedUrlForUpload,
  getShouldShowPostRecordingActions,
  getVideoPreview,
  selectVideo,
  showCameraRecorder,
  uploadVideoToBucket
} from '../../redux/modules/campaignLandingPage';
import styles from './PostRecordingActions.module.less';
import './fadeInAnimation.less';

const mimeTypeToExtensionMap = {
  'video/mp4': 'mp4',
  'video/quicktime': 'mov',
  'video/x-webm': 'mkv',
  'video/avi': 'avi',
  'video/x-msvideo': 'avi',
  'video/webm': 'webm',
  'video/divx': 'divx',
  'video/mpeg': 'mpeg',
  'video/mpeg2': 'm2v',
  'video/x-ms-wmv': 'wmv',
  'video/3gpp': 'tgp',
  'video/mp2p': 'mpeg2',
  'video/ogg': 'ogv',
  'video/x-flv': 'flv'
};

const PostRecordingActions = ({
  _cancelPostAction,
  _createMediaSubmission,
  _selectVideo,
  _showCameraRecorder,
  _uploadVideoToBucket,
  qid,
  shouldShowPostRecordingActions,
  signedUrl,
  userIpAddress,
  videoIsUploading,
  videoPreview,
  campaignId
}) => {
  if (!shouldShowPostRecordingActions && !videoIsUploading) {
    return null;
  }

  const actionsRef = useRef(null);

  // Create local state for file reference
  const [file, setFile] = useState(null);

  useEffect(() => {
    // Get a file reference from the blob URL
    // the first time the component renders
    const fileFromBlobUrl = async () => {
      const file = await fetch(videoPreview).then((r) => r.blob());
      const ext = mimeTypeToExtensionMap[file.type] || 'mp4';
      file.name = `recorded-video.${ext}`;

      // Store file ref in local state
      setFile(file);

      // Fade in
      actionsRef.current.classList.add('vpFadeIn');

      return file;
    };

    fileFromBlobUrl();
  }, []);

  useEffect(() => {
    if (signedUrl !== null && file && signedUrl) {
      _uploadVideoToBucket(file, signedUrl, qid);
    }
  }, [signedUrl]);

  const handleSave = () => {
    const mediaSubmission = {
      isRecorded: true,
      userAgent: navigator.userAgent,
      userIp: userIpAddress,
      screenResolution: `${window.outerWidth}x${window.outerHeight}`,
      mimeType: file.type,
      campaignId
    };

    // Send the file reference, urlType
    // when preSignedUrl changes,
    // it'll be persisted to a bucket
    _createMediaSubmission(mediaSubmission, qid);
  };

  const handleReRecord = () => {
    // null out existing blob url
    _selectVideo(qid, null);
    _showCameraRecorder(qid);
  };

  const handleCancel = () => {
    _selectVideo(qid, null);
    _cancelPostAction(qid);
  };

  return (
    <section className={styles.vpPostRecordingActionsSection} ref={actionsRef}>
      {videoIsUploading ? (
        <Loader size="md" />
      ) : (
        <>
          <div className={styles.vpPostRecordingActionButton} onClick={handleCancel}>
            <Icon icon="close" />
            <div>Cancel</div>
          </div>
          <div className={styles.vpPostRecordingActionButton} onClick={handleReRecord}>
            <Icon icon="refresh" />
            <div>Redo Recording</div>
          </div>
          <div className={styles.vpPostRecordingActionButton} onClick={handleSave}>
            <Icon icon="thumbs-up" />
            <div>Looks Good</div>
          </div>
        </>
      )}
    </section>
  );
};

PostRecordingActions.propTypes = {
  _cancelPostAction: PropTypes.func,
  _createMediaSubmission: PropTypes.func,
  _selectVideo: PropTypes.func,
  _showCameraRecorder: PropTypes.func,
  _uploadVideoToBucket: PropTypes.func,
  campaignElement: PropTypes.object,
  shouldShowPostRecordingActions: PropTypes.bool,
  signedUrl: PropTypes.string,
  userIpAddress: PropTypes.string,
  videoIsUploading: PropTypes.bool,
  videoPreview: PropTypes.string,
  campaignId: PropTypes.number,
  qid: PropTypes.string
};

function mapStateToProps(state, ownProps) {
  return {
    campaignElement: getCampaignElementById(state, ownProps.qid),
    shouldShowPostRecordingActions: getShouldShowPostRecordingActions(state, ownProps.qid),
    signedUrl: getPreSignedUrlForUpload(state, ownProps.qid),
    userIpAddress: getIpAddress(state),
    videoIsUploading: getIsVideoUploadingToBucket(state, ownProps.qid),
    videoPreview: getVideoPreview(state, ownProps.qid),
    campaignId: getCampaignId(state)
  };
}

const mapDispatchToProps = {
  _cancelPostAction: cancelPostAction,
  _createMediaSubmission: createMediaSubmission,
  _selectVideo: selectVideo,
  _showCameraRecorder: showCameraRecorder,
  _uploadVideoToBucket: uploadVideoToBucket
};

export default connect(mapStateToProps, mapDispatchToProps)(PostRecordingActions);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/PostRecordingActions.jsx